import { render, staticRenderFns } from "./partnerChangeLog.vue?vue&type=template&id=561d837d&"
import script from "./partnerChangeLog.vue?vue&type=script&lang=js&"
export * from "./partnerChangeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('561d837d')) {
      api.createRecord('561d837d', component.options)
    } else {
      api.reload('561d837d', component.options)
    }
    module.hot.accept("./partnerChangeLog.vue?vue&type=template&id=561d837d&", function () {
      api.rerender('561d837d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameLog/partnerChangeLog.vue"
export default component.exports